import { render } from "./BfFastSubmitted.vue?vue&type=template&id=ed78bf1e"
import script from "./BfFastSubmitted.vue?vue&type=script&lang=js"
export * from "./BfFastSubmitted.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__